
import { Link } from "react-router-dom";
import Logo from "./Logo";
import { cn } from "@/lib/utils";

const Navbar = () => {
  const navItems = [
    { path: "/blog", label: "Blog" },
    { path: "/about", label: "About" },
    { path: "/contact", label: "Contact" },
    { path: "/privacy", label: "Privacy Policy" },
  ];

  return (
    <nav className="py-4 px-4 md:px-8 flex items-center justify-between bg-white shadow-sm">
      <Logo />
      <div className="flex gap-2 md:gap-6">
        {navItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className={cn(
              "text-sm md:text-base font-medium text-gray-600 hover:text-[#6B4EE6] transition-colors"
            )}
          >
            {item.label}
          </Link>
        ))}
      </div>
    </nav>
  );
};

export default Navbar;
